import dayjs from "dayjs";

export const TIMEZONE_OPTIONS = [
  { value: "CST", label: "CST" },
  { value: "PST", label: "PST" },
  { value: "EST", label: "EST" },
  { value: "MST", label: "MST" },
];

export const PREFERRED_OUTREACH_OPTIONS = [
  {
    key: "9-10",
    label: "9:00 am - 10:00 am CST",
    startTime: "09:00:00",
    endTime: "10:00:00",
    timezone: "CST",
  },
  {
    key: "11-12",
    label: "11:00 am - 12:00 pm CST",
    startTime: "11:00:00",
    endTime: "12:00:00",
    timezone: "CST",
  },
  {
    key: "2-3",
    label: "2:00 pm - 3:00 pm CST",
    startTime: "14:00:00",
    endTime: "15:00:00",
    timezone: "CST",
  },
];

export const parseTimeToDayjs = (timeStr) => {
  if (!timeStr) return null;
  return dayjs(`1970-01-01 ${timeStr}`);
};

export const buildPreferredOutreachFromApi = (outreachWindows = []) => {
  const predefined = [...PREFERRED_OUTREACH_OPTIONS];
  const options = [...predefined];
  const selected = [];

  const formatLabel = (w) => {
    const start = dayjs(`1970-01-01 ${w.startTime}`);
    const end = dayjs(`1970-01-01 ${w.endTime}`);
    return `${start.format("h:mm a")} - ${end.format("h:mm a")} ${w.timezone}`;
  };

  const keyFor = (w) => {
    const m = predefined.find(
      (p) =>
        p.startTime === w.startTime &&
        p.endTime === w.endTime &&
        p.timezone === w.timezone,
    );
    if (m) return m.key;
    return w.id != null
      ? `custom_${w.id}`
      : `custom_${w.startTime}_${w.endTime}_${w.timezone}`;
  };

  for (const w of outreachWindows) {
    const k = keyFor(w);
    const isPredefinedKey = predefined.some((p) => p.key === k);
    if (!isPredefinedKey) {
      const exists = options.some((o) => o.key === k);
      if (!exists) {
        options.push({
          key: k,
          label: formatLabel(w),
          isCustome: true,
          startTime: w.startTime,
          endTime: w.endTime,
          timezone: w.timezone,
        });
      }
    }
    if (w.isActive) {
      selected.push({
        key: k,
        startTime: w.startTime,
        endTime: w.endTime,
        timezone: w.timezone,
        isCustom: !!w.isCustom,
      });
    }
  }

  return { options, selected };
};

export const buildInitialRestartForm = (c) => {
  if (!c) return null;
  const tz = c.startTimezone || c.endTimezone || "CST";
  const outreach = buildPreferredOutreachFromApi(c.outreachWindows || []);
  return {
    coverageStartDate: c.coverageStartDate ? dayjs(c.coverageStartDate) : null,
    campaignStartDate: c.campaignStartDate ? dayjs(c.campaignStartDate) : null,
    campaignStartTime: parseTimeToDayjs(c.campaignStartTime),
    campaignEndDate: c.campaignEndDate ? dayjs(c.campaignEndDate) : null,
    campaignEndTime: parseTimeToDayjs(c.campaignEndTime),
    campaignTimeZone: tz,
    blackoutDates: [...(c.blackoutDates || [])],
    preferredOutreachTimes: outreach.selected,
  };
};

export const buildOutreachWindowsForRestart = (campaignData) =>
  (campaignData?.outreachWindows || []).map((w) => ({
    startTime: w.startTime,
    endTime: w.endTime,
    timezone: w.timezone,
    isCustom: !!w.isCustom,
    isActive: w.isActive !== false,
  }));

/**
 * Builds POST body for admin/campaign/update (restart flow).
 */
export const buildRestartCampaignUpdatePayload = ({
  campaignData,
  restartForm,
  campaignId,
  refBrandId,
  preferredOutreachOptions,
}) => {
  if (!campaignData || !restartForm) return null;
  const rf = restartForm;
  const start = rf.campaignStartDate.startOf("day");
  const end = rf.campaignEndDate.startOf("day");
  const filteredBlackouts = (rf.blackoutDates || []).filter((dateStr) => {
    const d = dayjs(dateStr).startOf("day");
    return (
      (d.isAfter(start) || d.isSame(start)) &&
      (d.isBefore(end) || d.isSame(end))
    );
  });

  const mappedOutreachWindows = (preferredOutreachOptions || []).map((opt) => {
    const isActive = (rf.preferredOutreachTimes || []).some(
      (item) => item.key === opt.key,
    );
    return {
      startTime: opt.startTime,
      endTime: opt.endTime,
      timezone: opt.timezone,
      isCustom: !!opt.isCustome,
      isActive,
    };
  });

  const payload = {
    id: campaignId,
    refBrandId: refBrandId,
    coverageStartDate: dayjs(rf.coverageStartDate).format("YYYY-MM-DD"),
    campaignStartDate: dayjs(rf.campaignStartDate).format("YYYY-MM-DD"),
    campaignStartTime: dayjs(rf.campaignStartTime).format("HH:mm:ss"),
    startTimezone: rf.campaignTimeZone,
    campaignEndDate: dayjs(rf.campaignEndDate).format("YYYY-MM-DD"),
    campaignEndTime: dayjs(rf.campaignEndTime).format("HH:mm:ss"),
    endTimezone: rf.campaignTimeZone,
    blackoutDates: filteredBlackouts,
    status: "RESTART",
    outreachWindows:
      mappedOutreachWindows.length > 0
        ? mappedOutreachWindows
        : buildOutreachWindowsForRestart(campaignData),
  };
  return payload;
};
